import {
  Box,
  Flex,
  Text,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Image,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import BookEdit from "@root/assets/icons/bookEdit.svg";
import ArrowTopRight from "@root/assets/icons/arrowTopRight.svg";
import { useEffect } from "react";
import { useJournalistContext } from "@root/context/journalist-context";
import { useNavigate } from "react-router-dom";

const cardBg = "white";
const cardBorder = "1px solid #E4EBF0";
const cardRadius = "16px";

export const TopCourses = () => {
  const { t } = useTranslation("common");
  const { fetchTopCourses, topCourses } = useJournalistContext();
  const navigate = useNavigate();
  useEffect(() => {
    fetchTopCourses();
  }, []);

  const noCoursesFound = () => (
    <Flex
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      height="70%"
      py={8}
    >
      <Image src={BookEdit} />
      <Text fontWeight={600} mt={3}>
        {t("topCourses.noEnrolledCourse")}
      </Text>
    </Flex>
  );

  return (
    <Box
      flex="1"
      bg={cardBg}
      border={cardBorder}
      borderRadius={cardRadius}
      minW="320px"
      style={{ border: "1px solid #CDD6DC" }}
      data-tour-item="pledge-dashboard-top-courses"
    >
      <Flex
        justify="space-between"
        align="center"
        p={4}
        mb={4}
        bg="#F9F8FF"
        borderTopRadius={cardRadius}
      >
        <Text fontWeight="bold">{t("topCourses.title")}</Text>
        <Button
          variant="link"
          color="gray"
          fontSize="14px"
          fontWeight="500"
          size="sm"
          onClick={() => navigate("/pledge/courses")}
        >
          {t("topCourses.viewDetails")}
          <Box ml={3}>
            <Image src={ArrowTopRight} />
          </Box>
        </Button>
      </Flex>

      {topCourses?.length ? (
        <Box maxH="250px" overflowY="auto">
          <Table size="md" variant="simple">
            <Thead>
              <Tr>
                <Th fontSize="12px" fontWeight={500} color="gray">
                  {t("topCourses.courseName")}
                </Th>
                <Th fontSize="12px" fontWeight={500} color="gray">
                  {t("topCourses.category")}
                </Th>
                <Th fontSize="12px" fontWeight={500} color="gray">
                  {t("topCourses.enrolledUsers")}
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {topCourses?.map(
                (
                  course: {
                    title: string;
                    categoryTitle: string;
                    enrolledCount: number;
                  },
                  idx: number,
                ) => (
                  <Tr key={idx}>
                    <Td>{course?.title}</Td>
                    <Td>{course?.categoryTitle}</Td>
                    <Td>{course?.enrolledCount}</Td>
                  </Tr>
                ),
              )}
            </Tbody>
          </Table>
        </Box>
      ) : (
        noCoursesFound()
      )}
    </Box>
  );
};
